import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AuthenticationService } from './authentication.service';
import {ApplicationTokenService} from '../../core/services/application-token/application-token.service';
import { ConfigurationService } from '../configuration/configuration.service';
import { Url } from '../../core/models/url';

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  public static readonly BYPASS_HEADER = 'X-Skip-Header-Interceptor';

  constructor(
    private authenticationService: AuthenticationService,
    private applicationTokenService: ApplicationTokenService,
    private configAction: ConfigurationService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(AuthenticationInterceptor.BYPASS_HEADER)) {
      return next.handle(req);
    }
      const appToken = req.url.includes( Url.getFlowableProtectedApiBaseUrl(this.configAction)) ? this.applicationTokenService.getApplicationTokenWkfFromSessionStorage() : this.applicationTokenService.getApplicationTokenFromSessionStorage();
      return next.handle(req.clone({

        setHeaders: {
          'X-Refresh-Authorization': this.authenticationService.getAuthorizationToken(),
          'Authorization': appToken
        }
      })).pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (!!event.headers) {
            const headers = event.headers as HttpHeaders;
            if (!headers) {
              return;
            }
            const cacheControl: string = headers.get('Cache-Control');
            if (!cacheControl || cacheControl.indexOf('no-store') > -1) {
              let token = headers.get(AuthenticationService.APP_AUTHORIZATION_HEADER);
                if (!!token) {
                  token = token.substring(AuthenticationService.BEARER_PREFIX_LENGTH);
                  if(req.url.includes( Url.getFlowableProtectedApiBaseUrl(this.configAction) )) {
                    if (this.applicationTokenService.setApplicationTokenWkfIntoSessionStorage(token)) {
                      this.authenticationService.clearCachedWkfUserCredentials()
                    }
                  } else {
                    if (this.applicationTokenService.setApplicationTokenIntoSessionStorage(token)) {
                      this.authenticationService.clearCachedUserCredentials()
                    }
                  }

                  }
                }
            }
          }
      }));

  }

}
